/*
 *
 * GenericToast
 *
 * @version 1.0.0
 * @author tfrazzet
 * @since 18-Sep-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantToastMessage from '@nexidigital/merchanttoastmessage'
import './GenericToast.scss'

const GenericToast = (props) =>
  props.severity && (
    <Toggle>
      <div className='genericToast'>
        <MerchantToastMessage
          severity={props.severity}
          icon={false}
          label={props.label}
          directionSlide={props.directionSlide}
          duration={props.duration}
          onClose={() => {
            props.actions.doHideToast()
            props.onClose()
          }}
        />
      </div>
    </Toggle>
  )

GenericToast.propTypes = {
  /** This prop is expected to be an object. It represents the store's actions dispatched by component */
  actions: PropTypes.object,
  /** This prop is expected to be a string. It represents the severity of the message */
  severity: PropTypes.string.isRequired,
  /** This prop is expected to be a string. It represents the icon name of the message. If this prop is not passed, the message will not have an icon */
  iconName: PropTypes.string,
  /** This prop is expected to be a string. It represents the message to be displayed */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /** This prop is expected to be a number. It represents the duration of the message in milliseconds */
  duration: PropTypes.number,
  /** This prop is expected to be a string. It represents the direction of the slide (down,up) */
  directionSlide: PropTypes.string,
  /** This prop is expected to be a function.  */
  onClose: PropTypes.func
}

GenericToast.defaultProps = {
  actions: {},
  severity: '',
  label: '',
  duration: 15000,
  directionSlide: 'down',
  onClose: () => { }
}

export default GenericToast
